var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiRadio from '@mui/material/Radio';
import { forwardRef } from 'react';
import colors from '../../colors';
var UncheckedIcon = function () {
    return (_jsx("svg", __assign({ "data-testid": "RadioUncheckedIcon", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("circle", { cx: "8", cy: "8", r: "7", fill: "white", stroke: colors.grey[800], strokeWidth: "2" }) })));
};
var CheckedIcon = function () {
    return (_jsx("svg", __assign({ "data-testid": "RadioCheckedIcon", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("circle", { cx: "8", cy: "8", r: "5.5", fill: "white", stroke: colors.blue[500], strokeWidth: "5" }) })));
};
var Radio = forwardRef(function (props, ref) {
    return _jsx(MuiRadio, __assign({ ref: ref, icon: _jsx(UncheckedIcon, {}), checkedIcon: _jsx(CheckedIcon, {}) }, props));
});
export default Radio;
